import { usePunditUserContext } from "@circle-react/contexts";

export const useIsPaywallCustomizationPhase2 = () => {
  const { currentCommunitySettings } = usePunditUserContext();
  return Boolean(
    currentCommunitySettings?.paywalls_checkout_customization_phase2_enabled,
  );
};
